// Configurable default customer properties to be auto-saved right after customer creation.
// Map: AttributeTypeCode (number) -> AttributeCode (string)
// Fill in with your real codes. Example guesses are commented.
// Example:
//  - Çalıştığı Şirketler (type 2?) -> "99"
//  - Çalıştığı Markalar (type 3?) -> "0" (ya da boş)
//  - Eski Kodu (type 4?) -> ""

export const DEFAULT_CUSTOMER_PROPERTIES: Record<number, string> = {
  // Fatura Şekli (type 1) bilerek defaultlanmıyor; per-DB seçimler UI'dan iletilir.
  2: "99", // Çalıştığı Şirketler
  3: "10,11,13"   // Çalıştığı Markalar
};

// Lookup (fiyat/iskonto) için merkezi default değerler (genel fallback)
export const DEFAULT_PRICE_GROUP_CODE = 'TSF';
// İskonto grubu: kullanıcı seçmediyse BLANK kalsın. Otomatik 12 ataması istenmiyor.
export const DEFAULT_DISCOUNT_GROUP_CODE = '';

// Veritabanına (tenant) göre değişebilen lookup defaultları
// Anahtar: localStorage'da tutulan 'selectedDatabaseName' değeri
export type LookupDefaults = { priceGroupCode: string; discountGroupCode: string };

export const DB_LOOKUP_DEFAULTS: Record<string, LookupDefaults> = {
  // Örnek değerler. İstediğin gibi güncelleyebilirsin.
  V3_StDeri: { priceGroupCode: 'TSF', discountGroupCode: '12' },
  V3_StDeriLTD: { priceGroupCode: 'TSF', discountGroupCode: '12' },
  V3_SerkanCanta: { priceGroupCode: 'TSF', discountGroupCode: '12' },
  V3_SerkanCantaLTD: { priceGroupCode: 'TSF', discountGroupCode: '12' }
};

// Aktif veritabanı adına göre lookup defaultlarını döndürür.
export function resolveLookupDefaults(): LookupDefaults {
  try {
    const dbName = localStorage.getItem('selectedDatabaseName') || '';
    if (dbName && DB_LOOKUP_DEFAULTS[dbName]) {
      return DB_LOOKUP_DEFAULTS[dbName];
    }
  } catch (_) {
    // SSR vb. durumlarda localStorage yoksa sessiz geç
  }
  // Fallback genel sabitlere
  return { priceGroupCode: DEFAULT_PRICE_GROUP_CODE, discountGroupCode: DEFAULT_DISCOUNT_GROUP_CODE };
}

// Satış temsilcisi defaultları (opsiyonel). Anahtar: selectedDatabaseName
// Değerler iş birimlerinden teyit edilince güncellenebilir. Boş string gönderilirse backend atama yapmayacaktır.
const DB_SALESMAN_DEFAULTS: Record<string, string> = {
  V3_StDeri: '',
  V3_StDeriLTD: '',
  // SERKAN ÇANTA tarafı: tüm müşteriler için default 204 - Mağaza
  V3_SerkanCanta: '204',
  V3_SerkanCantaLTD: '204'
};

export function resolveDefaultSalesmanCode(): string {
  try {
    const dbName = localStorage.getItem('selectedDatabaseName') || '';
    if (dbName && Object.prototype.hasOwnProperty.call(DB_SALESMAN_DEFAULTS, dbName)) {
      return DB_SALESMAN_DEFAULTS[dbName] || '';
    }
  } catch (_) {
    // sessiz geç
  }
  return '';
}

// Bölge (StateCode) -> Satış temsilcisi kodu eşlemesi
// İhtiyaç: ST DERİ bölgesel, SERKAN ÇANTA mağaza sabitleri farklı olabilir.
// Buradaki mapping, form payload'ında SalesmanCode'u beslemek için kullanılır.
export function resolveSalespersonByRegion(stateCode: string | null | undefined): string {
  // Normalize input: trim, uppercase, unify separators, and ensure optional TR. prefix
  let code = (stateCode || '').trim().toUpperCase();
  if (!code) return '';
  code = code.replace(/[_-]/g, '.').replace(/\s+/g, '');

  // If user passes only region token (e.g., MR, EG, AK, GDA, KR, IC, DA), prepend TR.
  const KNOWN_TOKENS = new Set(['MR', 'EG', 'AK', 'GDA', 'KR', 'IC', 'DA']);
  if (!code.startsWith('TR.') && KNOWN_TOKENS.has(code)) {
    code = `TR.${code}`;
  }

  // Map groups
  // 207: Marmara
  if (code === 'TR.MR' || code.startsWith('TR.MR.')) return '207';
  // 210: Ege / Akdeniz / Güneydoğu Anadolu
  if (code === 'TR.EG' || code.startsWith('TR.EG.') || code === 'TR.AK' || code.startsWith('TR.AK.') || code === 'TR.GDA' || code.startsWith('TR.GDA.')) return '210';
  // 209: Karadeniz / İç Anadolu / Doğu Anadolu
  if (code === 'TR.KR' || code.startsWith('TR.KR.') || code === 'TR.IC' || code.startsWith('TR.IC.') || code === 'TR.DA' || code.startsWith('TR.DA.')) return '209';

  // Not matched -> let caller fallback (e.g., TSF)
  return '';
}

